import { useTheme } from "../context/ThemeContext";

export default function Btn({ children, primary, small, danger, disabled, onClick }) {
  return (
    <button onClick={onClick} disabled={disabled} style={{
      background: primary ? "var(--ink)" : danger ? "var(--red-bg)" : "var(--surface)",
      border: `1px solid ${primary ? "var(--ink)" : danger ? "var(--red-border)" : "var(--border)"}`,
      borderRadius: 6,
      padding: small ? "4px 10px" : "7px 14px",
      color: primary ? "var(--ink-text)" : danger ? "var(--red)" : "var(--text)",
      cursor: disabled ? "not-allowed" : "pointer",
      fontSize: small ? 11 : 12,
      fontWeight: 500,
      fontFamily: "inherit",
      opacity: disabled ? 0.45 : 1,
      whiteSpace: "nowrap",
      transition: "background 0.12s",
    }}>
      {children}
    </button>
  );
}
